import React from 'react';

const DomainStatusBadge = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'pending':
        return {
          color: 'warning',
          icon: 'fa-clock',
          text: 'Pending Admin Review'
        };
      case 'dns_updated':
        return {
          color: 'info',
          icon: 'fa-cog',
          text: 'DNS Configuration Required'
        };
      case 'active':
        return {
          color: 'success',
          icon: 'fa-check-circle',
          text: 'Active'
        };
      case 'failed':
        return {
          color: 'danger',
          icon: 'fa-exclamation-circle',
          text: 'Verification Failed'
        };
      case 'none':
      default:
        return {
          color: 'secondary',
          icon: 'fa-minus',
          text: 'No Domain Configured'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <span className={`badge badge-${config.color}`} style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem' }}>
      <i className={`fa-solid ${config.icon} mr-1`}></i>
      {config.text}
    </span>
  );
};

export default DomainStatusBadge;
